<template>
  <div>
    <div :class="$style.outer" v-if="editable">
      <div :class="$style.tags">
        <div :class="$style.tag" :style="tagStyle" v-for="(item, index) in value" :key="item">
          <span>{{ optionsMap[item] ? optionsMap[item][labelKey] : item }}</span>
          <i :class="$style.icon" class="el-icon-delete" @click="onDel(index)"></i>
        </div>
      </div>
      <el-select
        v-if="selectShow"
        ref="selectRef"
        v-model="curSelect"
        :placeholder="remote ? '输入工号/姓名查询' : '请选择'"
        filterable
        :remote="remote"
        :remote-method="remoteMethod"
        :loading="loading"
        @change="onAdd"
        @visible-change="onVisibleChange"
      >
        <el-option v-for="item in leftOptions" :key="item[valueKey]" :value="item[valueKey]" :label="item[labelKey]"></el-option>
      </el-select>
      <div v-else-if="!limit || limit > value.length" :class="$style.add__icon" @click="onSelectShow">
        <i  class="el-icon-circle-plus-outline"></i>
      </div>
    </div>
    <div v-else :class="[$style.text, showIsread ? '' : 'flex']">
      <div v-for="(item, index) in valueOptions" :key="index" class="mr20">
        {{ item.full_name }}  <span v-if="showIsread">（{{item.isread ? '已读' : '未读'}}）</span>
      </div>
      <span v-if="!valueOptions.length">--</span>
    </div>
  </div>
</template>
<script>
import { searchUser } from '../api'
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    form: Object,
    data: Object,
    editable: {
      type: Boolean,
      default: true
    },
    valueOptions: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    showIsread: {
      type: Boolean,
      default: false
    },
    tagStyle: String,
    showTextType: String,
    limit: {
      type: Number,
      default: 0
    },
    remote: {
      type: Boolean,
      default: true
    }
    
  },
  inject: ['detail'],
  data() {
    return {
      selectShow: false,
      curSelect: undefined,
      selectOptions: [],
      loading: false,
      searchOptionsMap: {},
    }
  },
  computed: {
    optionsMap () {
      let curatorsMap = this.getArrayMap(this.valueOptions)
      let map = this.getArrayMap(this.options)
      return {
        ...map,
        ...curatorsMap,
        ...this.searchOptionsMap,
      }
    },
    leftOptions () {
      let filterOptions = [
        ...this.filterOptions,
        ...this.value
      ]
      return this.selectOptions.filter(a => !filterOptions.includes(a[this.valueKey]))
    },
  },
  methods: {
    getArrayMap(arr) {
      if (!arr) return {}
      return arr.reduce((map, item) => {
        map[item[this.valueKey]] = item
        return map
      }, {})
    },
    onSelectShow() {
      this.selectOptions = this.options
      this.selectShow = true
      this.$nextTick(() => {
        this.$refs.selectRef.focus()
      })
    },
    onSelectHide () {
      this.selectShow = false
      this.curSelect = undefined
    },
    onVisibleChange(visible) {
      if (!visible) {
        this.onSelectHide()
      }
    },
    onDel(index) {
      let arr = [...this.value]
      arr.splice(index, 1)
      this.$emit('input', arr)
    },
    onAdd (val) {
      let arr = [...this.value]
      arr.push(val)
      this.$emit('input', arr)
      this.onSelectHide()
    },
    async remoteMethod(val) {
      if (!val) {
        this.selectOptions = this.options
        return
      }
      this.loading = true
      try {
        let { data } = await searchUser({
          username: val
        })
        let searchData = []
        if (data && data.length) {
          searchData = data.map(a => ({
            ...a,
            [this.valueKey]: a[this.valueKey] || a.id,
            [this.labelKey]: a[this.labelKey] ||a.full_name
          }))
        }
        this.selectOptions = searchData
        this.searchOptionsMap = {
          ...this.searchOptionsMap,
          ...this.getArrayMap(searchData)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" module>
.outer {
  min-height: 25px;
}
.outer, .tags, .tag {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.tags {
  flex-wrap: wrap;
}
.tag {
  height: 20px;
  padding: 3px 10px;
  color: #fff;
  background-color: #f00;
  font-size: 13px;
  line-height: 14px;
  margin-right: 10px;
  border-radius: 3px;
  margin-bottom: 2px;
  box-sizing: border-box;
}
.icon {
  cursor: pointer;
  margin-left: 5px;
  // margin-top: 1px;
}
.add__icon {
  cursor: pointer;
  color: #000;
  font-size: 20px;
}
.add__item {
  line-height: 30px;
  padding: 0 5px;
  color: #101010;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    background-color: #e6f2f2;
    color: teal;
  }
}
.text {
  font-size: 13px;
}

.MaxHeight {
  max-height: 188px;
  overflow: auto;
}
</style>
